import { useEffect, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  isConsentTxId,
  readPendingConsentTx,
  savePendingConsentTx,
} from "./oauthService"

export const OAUTH_CONSENT_PATH = "/oauth/consent"

/**
 * Renders OUTSIDE the login gate. Remembers the transaction id of `/oauth/consent?tx=…`
 * (the id only — never a redirect URI) in sessionStorage, so it survives a sign-in that
 * leaves the page (social login, OTP redirect) and comes back to the app root.
 *
 * Pure side effect, renders nothing.
 */
export function PreAuthOAuthConsentCapture() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    if (pathname !== OAUTH_CONSENT_PATH) return
    const tx = new URLSearchParams(search).get("tx")
    if (isConsentTxId(tx)) savePendingConsentTx(tx)
  }, [pathname, search])

  return null
}

/**
 * Renders INSIDE the login gate, once per page load. If the user was sent through a login
 * with a consent transaction pending (and is not already on the consent page), take them back
 * to it. It only navigates: the user still has to press Approve — nothing is ever approved
 * automatically.
 */
export function OAuthConsentResume() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const checked = useRef(false)

  useEffect(() => {
    if (checked.current) return
    checked.current = true
    if (pathname === OAUTH_CONSENT_PATH) return
    const tx = readPendingConsentTx()
    if (tx) navigate(`${OAUTH_CONSENT_PATH}?tx=${tx}`, { replace: true })
  }, [navigate, pathname])

  return null
}
